import Swal from "sweetalert2";

const ShowErrorMsg = (errormsg: string) => {
  Swal.fire({
    title: "THẤT BẠI",
    text: errormsg,
    icon: "error",
    confirmButtonText: "Xác nhận",
    confirmButtonColor: "red",
  });
};

const ShowSuccessMsg = (successMsg: string) => {
  Swal.fire({
    title: "THÀNH CÔNG",
    text: successMsg,
    icon: "success",
    confirmButtonText: "Xác nhận",
    confirmButtonColor: "green",
  });
};

export { ShowErrorMsg, ShowSuccessMsg };
